import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { havePermission } from '../../../../redux/reducers/identity.reducer';


const ProtectedRoute = ({ component: Component, permissions, path, ...other }) => {
    const identity = useSelector((state: any) => state.identity.data);
    return havePermission(identity, permissions) ?
        <Route path={path} {...other}>{Component}</Route> :
        <Redirect to="/" />
};

export default ProtectedRoute;
